import { List } from 'immutable';
import { useContext } from 'react';
import ConditionBox from '../common/ConditionBox';
import SegmentationFiltersInstanceContext from '../../state/SegmentationFiltersInstanceContext';
import ViewerAddFilterButton from './ViewerAddFilterButton';
import styled from 'foundations-theming/utils';
import { Box } from 'foundations-components/transitional/components/Box';
import { jsx as _jsx } from "react/jsx-runtime";
const ViewerConditionsGroupQuickAddFilterContainer = styled.div.withConfig({
  displayName: "ViewerConditionsGroupQuickAddFilter__ViewerConditionsGroupQuickAddFilterContainer",
  componentId: "eboew2-0"
})(({
  useOnePanel
}) => ({
  display: 'inline-block',
  width: useOnePanel ? '100%' : undefined,
  '& > .condition-box': useOnePanel ? {
    borderColor: 'transparent'
  } : undefined
}));
const ViewerConditionsGroupQuickAddFilter = ({
  logicGroupIndex
}) => {
  const {
    isInEditMode,
    props: {
      useOnePanel
    }
  } = useContext(SegmentationFiltersInstanceContext);
  if (!isInEditMode) {
    return null;
  }
  return /*#__PURE__*/_jsx(ViewerConditionsGroupQuickAddFilterContainer, {
    useOnePanel: useOnePanel,
    children: /*#__PURE__*/_jsx(ConditionBox, {
      size: "sm",
      children: /*#__PURE__*/_jsx(Box, {
        children: /*#__PURE__*/_jsx(ViewerAddFilterButton, {
          parentGroupKeyPath: List.of(logicGroupIndex)
        })
      })
    })
  });
};
export default ViewerConditionsGroupQuickAddFilter;